module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            完成步驟後，再至\n            "), _c('router-link', {
    attrs: {
      "to": _vm.goToBuild
    }
  }, [_vm._v("\n              菜單建置\n            ")]), _vm._v("\n            建立菜單\n          ")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToBindingPos
    }
  }, [_c('button', {
    staticClass: "btn btn-detail-edit"
  }, [_vm._v("\n                1 - 建立菜單庫 (綁定商品料號)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToOption
    }
  }, [_c('button', {
    staticClass: "btn-a-o btn-detail-edit"
  }, [_vm._v("\n                2 - 配料 (option)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToAdjust
    }
  }, [_c('button', {
    staticClass: "btn-p-com btn-detail-edit"
  }, [_vm._v("\n                3 - 配料群組 (adjust)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToCategory
    }
  }, [_c('button', {
    staticClass: "btn-com-price btn-detail-edit"
  }, [_vm._v("\n                4 - 商品分類 (category)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToProduct
    }
  }, [_c('button', {
    staticClass: "btn-c-p btn-detail-edit"
  }, [_vm._v("\n                5 - 商品 (product)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToBlock
    }
  }, [_c('button', {
    staticClass: "btn-a-o btn-detail-edit"
  }, [_vm._v("\n                6 - 品項選擇區 (block)\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goToPackage
    }
  }, [_c('button', {
    staticClass: "btn-p-com btn-detail-edit"
  }, [_vm._v("\n                7 - 套餐 (package)\n              ")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            若無套餐需求，只需完成步驟 1~5\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b572db7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/menu-step.vue
// module id = 2493
// module chunks = 1